import type { Tracker, UserData } from './tracker'

export class MultiTracker implements Tracker {
  trackers: Tracker[]

  constructor(trackers: Tracker[]) {
    this.trackers = trackers
  }

  track(eventName: string, eventProperties: Record<string, any>) {
    this.trackers.forEach(tracker => {
      tracker.track(eventName, eventProperties)
    })
  }

  identify(userData: UserData) {
    this.trackers.forEach(tracker => {
      tracker.identify(userData)
    })
  }

  async getFeatureFlag(name: string): Promise<boolean | string | undefined> {
    for (const tracker of this.trackers) {
      if (await tracker.hasFeatureFlag(name)) {
        return tracker.getFeatureFlag(name)
      }
    }
    return Promise.resolve(false)
  }

  async hasFeatureFlag(name: string): Promise<boolean> {
    return (
      await Promise.all(
        this.trackers.map(tracker => tracker.hasFeatureFlag(name))
      )
    ).some(Boolean)
  }

  clear() {
    this.trackers.forEach(tracker => {
      tracker.clear()
    })
  }
}
